module.exports = __webpack_public_path__ + "media/stylesheets/resident/images/ico-map-w-d2ae5f62f3812913ffb6eaa8f6849f61.svg";